module.exports = __webpack_public_path__ + "app/images/sprite/svg-sprite.out.svg";